import React from "react";

const ConsignmentRemoteTable = () => {
  return <div>Consignment Table</div>;
};

export default ConsignmentRemoteTable;
